import React from "react";
import { Badge, MessageSquare01 } from "@opendate-app/setlist";

import BroadcastSidebar, { StepFooter } from "./BroadcastSidebar";
import { useBroadcastEditContext } from "./BroadcastEditContainer";
import SmsStatusAlert from "bundles/shared/components/SmsStatusAlert";

const styles = {
  heading: {
    color: "var(--sl-text-primary)",
    fontSize: 20,
    fontWeight: 600,
    marginBottom: 4,
  },
  description: {
    color: "var(--sl-text-tertiary)",
  },
  content: {
    border: "1px solid var(--sl-border-secondary)",
    borderRadius: 8,
    background: "var(--sl-bg-primary)",
    color: "var(--sl-text-primary)",
    padding: 16,
    cursor: "pointer",
    width: "100%",
    maxWidth: 400,
    marginTop: 24,
    display: "flex",
    flexDirection: "column",
    gap: 8,
    textAlign: "left",
  },
  contentHeader: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontSize: 14,
    fontWeight: 600,
  },
  message: {
    fontSize: 14,
  },
};

const TwilioContentTab = () => {
  const {
    broadcast,
    setTab,
    smsStatus,
  } = useBroadcastEditContext();

  return (
    <BroadcastSidebar>
      {!smsStatus.can_send && (
        <SmsStatusAlert
          variant={smsStatus.cta?.label === "Update Payment Method" ? "error" : "info"}
          title={smsStatus.reason}
          ctaLabel={smsStatus.cta?.label}
          ctaHref={smsStatus.cta?.path}
        />
      )}
      <h3 style={styles.heading}>Content</h3>
      <p style={styles.description}>Design the content of your SMS message.</p>
      <button type="button" style={styles.content} onClick={() => setTab("twilio-editor")}>
        <span style={styles.contentHeader}>
          <MessageSquare01 width={20} height={20} aria-hidden="true" />
          {broadcast.name}
          {!broadcast.twilio_template.template?.length && (
            <Badge color="gray" size="sm">No content</Badge>
          )}
        </span>
        {broadcast.twilio_template.template?.length > 0 && (
          <span style={styles.message}>
            {broadcast.twilio_template.template}
          </span>
        )}
      </button>
      <StepFooter onBack={() => setTab("recipients")} onNext={() => setTab("review-and-schedule")} />
    </BroadcastSidebar>
  );
};

export default TwilioContentTab;
